/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var BreadcrumbView = require('common/views/BreadcrumbView');

var DepProgressReportFormView = require('./DepProgressReportFormView');

var SubmitProgressReport = require('../services/SubmitProgressReport');

var tmplDepProgressReportNewView = require('../templates/DepProgressReportNewView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepProgressReportNewView,

  className: 'dep-progress-report-new-view container-fluid',

  ui: {
    progressReportForm: '.progress-report-form-container',
    breadcrumb: '.breadcrumb-container',
    submit: '.btn-submit'
  },

  regions: {
    progressReportForm: '@ui.progressReportForm',
    breadcrumb: '@ui.breadcrumb'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var enforcementIdentifiers = this.model.get('enforcementIdentifiers') || {};
    var entityName = enforcementIdentifiers.entityName;
    var effectiveDate = enforcementIdentifiers.effectiveDate;
    var enforcementId = this.model.get('enforcementId');
    var entityId = this.model.get('entityId');
    var enforcementAction = enforcementIdentifiers.action;

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            link: '#dep/entity/' + entityId + '/enforcement/' + enforcementId + '/dashboard',
            text: enforcementAction + ' - Effective as of ' + effectiveDate
          },
          {
            text: 'New Progress Report'
          }
        ]
      })
    );

    this.progressReportForm = new DepProgressReportFormView({
      model: this.model
    });

    this.showChildView('progressReportForm', this.progressReportForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        SubmitProgressReport(formData)
          .done(function() {
            Radio.channel('navigate').trigger(
              'show:int:dp:enforcement',
              self.model.get('entityId'),
              formData.enforcementId
            );
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.progressReportForm.parsley().whenValidate();
  },

  getFormData: function() {
    return this.progressReportForm.getFormData();
  }
});
